import { useEffect, useState, React } from "react";
import { BrowserRouter, Route, Routes, Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuthContext } from "../../Hooks/useAuthContext";
import Spinner from "../../Components/Loading/Spinner";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/free-solid-svg-icons'

import { apiService } from "../../Axios/apiService"; 

import { FarmFilters } from "./FarmFilters";

export default function ListCustomers() {
    const { user } = useAuthContext();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [farms, setFarms] = useState([]);

    const [filters, setFilters] = useState({
        farm: "",
        referredBy: "",
        primaryContact: "", 
        location: ""
    });

    

    

    // Load users
    const loadFarms = async (filterValues = filters) => {
        setLoading(true);
        console.log("loading farms...", user);

        apiService("get", `farms/?farm=${filterValues.farm}&referredBy=${filterValues.referredBy}&primaryContact=${filterValues.primaryContact}&location=${filterValues.location}`, null,
            (response) => {
                console.log("Users:", response);
                setFarms(response);
                setLoading(false);
            },
            (error) => {
                console.log(error);
                setLoading(false);
            }
        )

    }

    // Load farms
    useEffect(() => {
        loadFarms();
    }, []);

    return (
        <div className="page">
            <div className="row">
                <div className="col-12">
                    {loading && (<Spinner />)}
                    {!loading && (
                        <>
                        <h1>Farms <button className="btn-sm btn-primary" onClick={() => { navigate(`/Farms/Create/`) }}><FontAwesomeIcon icon={faPlus} /> Add</button> </h1>

                            <FarmFilters
                                filters={filters}
                                setFilters={setFilters}
                                onApply={() => loadFarms(filters)}
                            />


                        <table style={{width: "100%"}}>
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Referred By</th>
                                    <th>Location</th>
                                    <th>&nbsp;</th>
                                </tr>
                            </thead>
                            <tbody>
                                {farms && (farms.map((farm) => {
                                    return (
                                        <tr key={farm.id} style={{ cursor: "pointer" }}>
                                            <td onClick={() => navigate(`/Farms/View/${farm.id}`)}>
                                                {farm.name}
                                                {farm.businessName && ` (${farm.businessName})`}
                                                {farm.primaryContact && (
                                                    <span style={{ color: "#a0a0a0" }}>
                                                        {" - "}{farm.primaryContact}
                                                    </span>
                                                )}
                                            </td>
                                            <td onClick={() => { navigate(`/Farms/View/${farm.id}`) }}>{farm.referredBy}</td>
                                            <td onClick={() => { navigate(`/Farms/View/${farm.id}`) }}>{farm.location}</td>
                                            <td>
                                                <Link to={`/Farms/View/${farm.id}`} className="btn-sm btn-primary">View</Link>
                                                <Link to={`/Farms/Edit/${farm.id}`} className="btn-sm btn-other">Edit</Link>
                                            </td>
                                        </tr>
                                    )
                                }))}
                            
                            </tbody>
                        </table>
                        </>
                    )}
                </div>
            </div>
        </div>
  )
}
